import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedSelect = _resolveComponent("SharedSelect")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('buy'))
    }, [
      _createVNode(_component_SharedSelect, {
        view: "light",
        options: _ctx.buyCurrencyOptions,
        icon: _ctx.buyCurrencyIcon,
        value: _ctx.buyCurrencySelected.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.buyCurrencySelected.value) = $event))
      }, null, 8, ["options", "icon", "value"]),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('label'))
      }, _toDisplayString(_ctx.$t("Покупка")), 3),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('value'))
      }, _toDisplayString(_ctx.formatRate(_ctx.displayedBuyRate)), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('sell'))
    }, [
      _createVNode(_component_SharedSelect, {
        view: "light",
        options: _ctx.sellCurrencyOptions,
        icon: _ctx.sellCurrencyIcon,
        value: _ctx.sellCurrencySelected.value,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sellCurrencySelected.value) = $event))
      }, null, 8, ["options", "icon", "value"]),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('label'))
      }, _toDisplayString(_ctx.$t("Продажа")), 3),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('value'))
      }, _toDisplayString(_ctx.formatRate(_ctx.displayedSellRate)), 3)
    ], 2)
  ], 2))
}